const formatDate = date =>
  new Date(date).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour12: false,
  })

export default formatDate
